import { Routes } from '@angular/router';
import { FormComponent } from "@modules/landing/pages/form/form.component";
import { SearchComponent } from "@modules/landing/pages/search/search.component";
/** Pages */

export const LandingLayoutRoutes: Routes = [
  { path: '', redirectTo: 'form', pathMatch: 'full' },
  { path: 'form', component: FormComponent, pathMatch: 'full' },
  { path: 'search/:code', component: SearchComponent, pathMatch: 'full' },
  { path: '**', redirectTo: 'form', pathMatch: 'full' }
];
